import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangelogService } from '../../../../../src/app/core/services/changelog/changelog-service';
import { Changelog } from '../../../core/models/changelog.interface';

@Component({
  selector: 'app-changelog-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './changelogs.component.html',
  styleUrls: ['./changelogs.component.css']
})
export class ChangelogModalComponent {

  constructor(
    public dialogRef: MatDialogRef<ChangelogModalComponent>,
    @Inject(MAT_DIALOG_DATA) public changelogData: Changelog,
    private changelogService: ChangelogService
  ) {}

  closeModal(): void {
    if (this.changelogData?.id) {
      this.changelogService.MarkasRead(this.changelogData.id).subscribe({
        next: () => {
          this.dialogRef.close(); 
        },
        error: (err) => {
          console.error('Error al marcar como leído:', err);
          this.dialogRef.close(); 
        }
      });
    } else {
      this.dialogRef.close();
    }
  }
}